import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { CmsFacet, ConvertedComponentData, FsCatalog } from '../../../types'
import { CmsConverterService, defaultFSCatalog } from '../../../../services/cms-converter/cms-converter.service'
import { ProductFinderStepData } from '../product-finder-step/product-finder-step.component.converter'

@Injectable({ providedIn: 'root' })
export class ProductFinderConverter extends CmsConverterService<ProductFinderData> {
  convertData (source: CmsComponent): ProductFinderData {
    const formData = source?.otherProperties?.formData ?? {}
    return {
      items: formData.st_content ?? defaultFSCatalog,
      preselectedFacets: formData.pt_tags ?? [],
      preselectedCategories: formData.st_category_id.value ?? []
    }
  }
}

export const PRODUCT_FINDER_CONVERTER_TOKEN = new InjectionToken<Converter<CmsComponent, ProductFinderData>>('ProductFinderConverter')

export interface ProductFinderData extends ConvertedComponentData {
  items: FsCatalog<ProductFinderStepData>;
  preselectedFacets: Array<CmsFacet>;
  preselectedCategories: Array<string>;
}
